<div *ngIf="plants.length>1" class="jbm-plant-selector {{class}}">
  <label *ngIf="showLabel" [for]="id" class="float-start me-2">{{'company.plant'|translate}}</label>
  <select (change)="onChange($event)" [id]="id" class="form-control form-select float-start">
    <option value="-1">{{'ui.all'|translate}} {{'company.plants'|translate|lowercase}}</option>
    <option *ngFor="let plant of plants" value="{{plant.id}}" [selected]="selection==plant.id">
      {{plant.name}}
    </option>
  </select>
</div>
